module.exports = __webpack_public_path__ + "imgs/payment.9942d1cc8064898da7790528dac661f3.svg";